import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import { useLanguage } from "@/i18n";
import { useT } from "@/i18n_extra3";
import { BLOG_POSTS } from "@/data/blogPosts";

export default function BlogList() {
  const { lang } = useLanguage();
  const t = useT();
  return (
    <div className="App bg-[#FAF9F6] text-[#111111] min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 pt-40 pb-24 max-w-4xl mx-auto px-5 sm:px-8 w-full" data-testid="blog-list">
        <div className="flex items-center gap-3 mb-6">
          <span className="h-px w-10 bg-[#B8860B]" />
          <span className="text-xs font-bold tracking-[0.25em] uppercase text-[#B8860B]">{t.blogSection.label}</span>
        </div>
        <h1 className="font-display font-bold tracking-tight text-4xl sm:text-5xl">{t.blogSection.title}</h1>
        <div className="mt-14 space-y-6">
          {BLOG_POSTS.map((p) => (
            <Link
              key={p.slug}
              to={`/blog/${p.slug}`}
              data-testid={`blog-list-${p.slug}`}
              className="group flex items-start justify-between gap-6 border border-black/10 rounded-2xl p-8 bg-white/60 hover:border-[#D4AF37] hover:shadow-xl transition-all duration-500"
            >
              <div>
                <span className="text-[11px] font-bold tracking-widest uppercase text-[#B8860B]">{p.readMin} {t.blogSection.min}</span>
                <h2 className="mt-3 font-display font-semibold text-2xl leading-snug group-hover:text-[#B8860B] transition-colors">
                  {p.title[lang] || p.title.en}
                </h2>
                <p className="mt-2 text-black/55">{p.excerpt[lang] || p.excerpt.en}</p>
              </div>
              <ArrowUpRight className="w-6 h-6 mt-2 text-black/30 group-hover:text-[#B8860B] group-hover:translate-x-1 group-hover:-translate-y-1 transition-all shrink-0" />
            </Link>
          ))}
        </div>
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
